import BaseModalView from "scripts/views/baseModalView";
import template from "templates/chaptersDownloadModal.hbs";
import inject from "scripts/ioc/inject";
import L from "lodash/fp";

import DownloadUrlModel from "scripts/models/downloadUrlModel";

class ChaptersDownloadModalView extends BaseModalView {
  get template() {
    return template;
  }

  constructor(options, i18nextService = inject("i18nextService")) {
    super(options);

    this.i18nextService = i18nextService;

    this.compoundChildrenCollection = options.compoundChildrenCollection;

    this.downloadUrlModels = this.compoundChildrenCollection.map(
      mediaModel => new DownloadUrlModel({ contentModel: mediaModel }),
    );
  }

  async sync() {
    await Promise.all(this.downloadUrlModels.map(model => model.fetch()));
    return this;
  }

  render() {
    const chapterData = this.compoundChildrenCollection.map(
      (mediaModel, index) => ({
        title: mediaModel.get("title"),
        downloadUrl: this.downloadUrlModels[index].get("downloadUrl"),
      }),
    );

    const { close, download } = L.get(
      ["ariaLabel"],
      this.i18nextService.getAttributes(),
    );

    const downloadChapter = L.get(
      ["actions", "download", "chapter"],
      this.i18nextService.getCommon(),
    );

    this.$el.html(
      this.template({
        i18n: { close, download, downloadChapter },
        chapterData,
      }),
    );

    return this;
  }
}

export default ChaptersDownloadModalView;
